import _slicedToArray from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
/** *
 *  节流 每单位时间可触发一次
 *  第一次瞬间触发，最后一次不管是否达到间隔时间依然触发
 * 【考虑到input的change事件】
 *  @param {?Number|300} time - 间隔时间
 *  @param {Function} fn - 执行事件
 *  @param {?String|"click"} event - 事件类型 例："click"
 *  @param {Array} binding.value - [fn,event,time]
 *  例：<el-button v-throttle="[reset,`click`,300]">刷新</el-button>
 *  传递参数则：<el-button v-throttle="[()=>reset(param),`click`,300]">刷新</el-button>
 */
export default {
  inserted: function inserted(el, binding) {
    var _binding$value = _slicedToArray(binding.value, 3),
      fn = _binding$value[0],
      _binding$value$ = _binding$value[1],
      event = _binding$value$ === void 0 ? 'click' : _binding$value$,
      _binding$value$2 = _binding$value[2],
      time = _binding$value$2 === void 0 ? 1000 : _binding$value$2;
    var timer, timer_end;
    el.addEventListener(event, function () {
      // debugger
      if (timer) {
        // clearTimeout(timer_end);
        // timer_end = setTimeout(() => fn(), time);
        return;
      }
      fn();
      timer = setTimeout(function () {
        timer = null;
      }, time);
    });
  }
};